// 벌점 출처 배지 — 자동(시스템) / 순찰(사람이 순찰 중 기록) / 수동(직접 부과)
//   순찰 건이 "자동 부과"로 보여서 시스템이 매긴 것으로 오해되던 문제 (2026-07-30)
export const penaltySourceBadge = (
  referenceType?: string | null,
  isAuto?: boolean
): { label: string; className: string } => {
  const t = (referenceType || '').toLowerCase();
  if (t === 'patrol' || t === 'patrol_note') {
    return { label: '🔍 순찰', className: 'bg-purple-100 text-purple-700' };
  }
  if (t === 'auto' || isAuto) {
    return { label: '⚙️ 자동', className: 'bg-blue-100 text-blue-700' };
  }
  return { label: '✋ 수동', className: 'bg-gray-100 text-gray-600' };
};
